export default __webpack_public_path__ + "static/scientist3-95faeff5f3eaf8a1bc00bcd413bdbea8.png";